"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _detectBrowser = require("detect-browser");

var _Error = _interopRequireWildcard(require("./../Messages/Error"));

var _ValidationIcons = _interopRequireDefault(require("./../Inputs/ValidationIcons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 100%;\n  border: 0.1rem solid;\n  border-color: ", ";\n  border-radius: 0.3rem;\n  height: 4rem;\n  font-size: 1.6rem;\n  padding: 1rem;\n  min-height: 7rem;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  font-size: 1.4rem;\n  margin-bottom: 0.7rem;\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  &::after {\n    content: ", ";\n    position: absolute;\n    bottom: 20px;\n    right: 15px;\n    height: 13px;\n    max-width: 74px;\n    display: block;\n    white-space: nowrap;\n    font-size: 1.5rem;\n    line-height: 1.3rem;\n    letter-spacing: 0.924996px;\n    color: #dfdfdf;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: ", ";\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextArea = function TextArea(_ref) {
  var className = _ref.className,
      children = _ref.children,
      name = _ref.name,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      setFieldTouched = _ref.setFieldTouched,
      error = _ref.error,
      warning = _ref.warning,
      touched = _ref.touched,
      value = _ref.value,
      maxLength = _ref.maxLength,
      counter = _ref.counter,
      otherProps = _objectWithoutProperties(_ref, ["className", "children", "name", "disabled", "placeholder", "onChange", "setFieldTouched", "error", "warning", "touched", "value", "maxLength", "counter"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var _useState5 = (0, _react.useState)('1rem'),
      _useState6 = _slicedToArray(_useState5, 2),
      iconRight = _useState6[0],
      setIconRight = _useState6[1];

  var browser = (0, _detectBrowser.detect)();

  var handleChange = function handleChange(e) {
    e.persist();
    setInputValue(e.target.value);
    onChange({
      name: e.target.name,
      value: e.target.value
    });
  };

  var handleFocus = function handleFocus() {
    setFocus(true);

    if (browser) {
      switch (browser.name) {
        case 'safari':
          setIconRight('3.5rem');
          break;

        case '':
          setIconRight('3.5rem');
          break;

        default:
          setIconRight('1rem');
          break;
      }
    }
  };

  (0, _react.useEffect)(function () {
    if (inputValue !== value) {
      setInputValue(value);
    }
  }, [value]);

  var handleBlur = function handleBlur() {
    setFieldTouched(name, true);
    setFocus(false);
  };

  return _react.default.createElement(Container, {
    className: className
  }, _react.default.createElement(StyledLabel, {
    disabled: disabled,
    htmlFor: name
  }, children), _react.default.createElement(InputContainer, null, _react.default.createElement(Count, {
    maxLength: maxLength,
    count: value.length,
    counter: counter
  }, _react.default.createElement(StyledTextArea, _extends({}, otherProps, {
    id: name,
    name: name,
    disabled: disabled,
    placeholder: placeholder,
    error: error,
    warning: warning,
    touched: touched,
    value: inputValue,
    maxLength: maxLength,
    count: value.length,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  }))), _react.default.createElement(_ValidationIcons.default, {
    error: error,
    browser: browser,
    focus: focus,
    iconRight: iconRight,
    touched: touched
  })), _react.default.createElement(_Error.default, {
    error: error,
    warning: warning
  }));
};

var Container = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var Count = _styledComponents.default.div(_templateObject2(), function (_ref3) {
  var count = _ref3.count,
      maxLength = _ref3.maxLength,
      counter = _ref3.counter;
  return counter ? "'".concat(count, " / ").concat(maxLength || '∞', "'") : '';
});

var StyledLabel = _styledComponents.default.label(_templateObject3(), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? '#AEAEAE' : '#5B5550';
});

var InputContainer = _styledComponents.default.div(_templateObject4());

var StyledTextArea = _styledComponents.default.textarea(_templateObject5(), function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? '#F0F1F3' : 'white';
}, function (_ref6) {
  var error = _ref6.error,
      touched = _ref6.touched,
      theme = _ref6.theme,
      warning = _ref6.warning;
  return (0, _Error.getBorderColor)(error, touched, theme, warning);
});

TextArea.defaultProps = {
  disabled: false,
  placeholder: '',
  error: '',
  warning: '',
  value: '',
  touched: false,
  setFieldTouched: function setFieldTouched() {},
  onChange: function onChange() {},
  otherProps: {}
};
TextArea.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** label above the input */
  children: _propTypes.node.isRequired,

  /** name of input and label */
  name: _propTypes.string.isRequired,

  /** if true input is disabled */
  disabled: _propTypes.bool,

  /** example value in the input */
  placeholder: _propTypes.string,

  /** string with errormessage */
  error: _propTypes.string,

  /** string with warningmessage */
  warning: _propTypes.string,

  /** boolean to check if inputfield is touched */
  touched: _propTypes.bool,

  /** returns name and touched boolean */
  setFieldTouched: _propTypes.func,

  /** returns onChange event */
  onChange: _propTypes.func,

  /** max input length */
  maxLength: _propTypes.number,

  /** boolean to set counter visibility */
  counter: _propTypes.bool,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,

  /** sets initial value */
  value: _propTypes.string
};
var _default = TextArea;
exports.default = _default;